// Mobile CTA reveal motion (STOK-17405): a plain opacity cross-fade, timed off
// the designer's motion clip, which fades the search, wishlist, and account
// actions in over ~400ms with no positional movement. Note this is NOT the Figma
// "SPECS / ANIMATIONS — Slide in" card (16px rise, 0.05s between elements) —
// that annotation covers the flyout's own content, not the header buttons,
// which the spec never annotates.
// DESIGN-ISSUE(STOK-17031): the durations token scale tops out at `slowest`
// (500ms) with no 400ms step and no easing token matches this curve, so both
// stay hardcoded literals, as in `flyout/index.recipe.js` and
// `hamburger-icon.recipe.js`. The pair mirrors the flyout panel's own mobile
// reveal so the cluster and the panel it belongs to settle together.
const CTA_REVEAL_DURATION = '0.4s'
const CTA_REVEAL_EASE = 'cubic-bezier(0, 0, 0, 1)'

export const CTA_REVEAL_TRANSITION = {
    transitionProperty: 'opacity, display',
    transitionDuration: CTA_REVEAL_DURATION,
    transitionTimingFunction: CTA_REVEAL_EASE,
    // `display` is a discrete property: without this the `none` to
    // `inline-flex` flip is instant and the opacity transition never paints.
    transitionBehavior: 'allow-discrete',
    _motionReduce: {
        transitionDuration: '0.01ms'
    }
}
